export default __webpack_public_path__ + "static/media/talk_white.d6822a49.svg";